const FlagSE = props => (
	<svg height="28" viewBox="0 0 200 200" width="28" {...props}>
		<rect fill="#4a89dc" width="200" height="200" />
		<rect fill="#ffce54" x="-4" y="85" width="208" height="30" transform="translate(200) rotate(90)" />
		<rect fill="#ffce54" x="-4" y="85" width="208" height="30" transform="translate(200 200) rotate(180)" />
	</svg>
);

export default FlagSE;
